/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import GoogleAnalytics from '../../GoogleAnalytics';
import { IToggle } from './IToggle';
import NodeTouchActionComponent from './NodeTouchActionComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** An extension of [[ActionComponentBase]] that toggles on touches on the attached node. */
@cc._decorator.ccclass
export default class NodeToggleActionComponent extends NodeTouchActionComponent implements IToggle
{
    /** Tween target when toggled on. */
    @property({ type: [cc.Component.EventHandler], visible: true })
    private _toggleOnHandlers: cc.Component.EventHandler[] = [];

    /** Toggle on tween duration. */
    @property({ type: [cc.Component.EventHandler], visible: true })
    private _toggleOffHandlers: cc.Component.EventHandler[] = [];

    /** Whether touching the canvas should toggle off. */
    @property()
    protected clickCanvasToDismiss: boolean = true;

    /** Whether the toggle starts on or not. */
    @property({ visible: true })
    private _isOn: boolean = false;

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.configureCanvasTouchHandler();
    }

    /** Configures handler to toggle off on canvas touch. */
    private configureCanvasTouchHandler(): void
    {
        if (!this.clickCanvasToDismiss) { return; }

        let canvasTouchAction: NodeTouchActionComponent = this.node.addComponent(NodeTouchActionComponent);
        canvasTouchAction.TargetNode = cc.Canvas.instance.node;
        canvasTouchAction.Action = this.onCanvasTouchEndHandler;
    }

    /** Canvas touch handler. */
    private onCanvasTouchEndHandler = (event: cc.Event.EventTouch) =>
    {
        if (event.target !== this.node) { this.ToggleOff(); }
    }

    /** Manually turns off the toggle. */
    public ToggleOff(): void
    {
        this.toggle(false, true);
    }

    /** Manually turns on the toggle. */
    public ToggleOn(): void
    {
        this.toggle(true, false);
    }

    /** @hidden */
    protected action = (): void =>
    {
        this.toggle(!this._isOn);
    }

    /** @hidden */
    protected toggle = (isOn: boolean = false, force: boolean = false): void =>
    {
        if (!this.enabled && !force) { return; }

        if (isOn && !this._isOn)
        {
            for (let handler of this._toggleOnHandlers)
            {
                handler.emit([handler.customEventData]);
            }

            GoogleAnalytics.ToggleEvent(this.node.name, isOn);
        }
        else if (!isOn && this._isOn)
        {
            for (let handler of this._toggleOffHandlers)
            {
                handler.emit([handler.customEventData]);
            }

            GoogleAnalytics.ToggleEvent(this.node.name, isOn);
        }

        this._isOn = isOn;
    }
}
